<script>
  import { onMount } from "svelte";
  import { formatDate, PPPlaceholder, dateInitializer } from "../../helpers/utils.svelte";

  import { Calendar } from "@fullcalendar/core";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import "./calendar.css";

  import Card from "../Card/index.svelte";
  import ReservationDrawer from "./ReservationDrawer.svelte";

  export let selectedProperty;
  export let onDateChange = null;
  let calendarContainer;
  let calendarInstance;
  let selectedReservation;
  // TODO :: Hover problems on splitted event boxes
  onMount(async () => {
    initializeCalendar();
  });

  function initializeCalendar() {
    calendarInstance = new Calendar(calendarContainer, {
      plugins: [dayGridPlugin],
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "",
      },
      selectable: false,
      selectMirror: false,
      showNonCurrentDates: false,
      eventDisplay: "block",
      eventLimit: true,
      editable: false,
      initialDate: formatDate(dateInitializer(), 'Y-m-d'),
      weekNumbers: false,
      navLinks: false,
      nowIndicator: true,
      eventTextColor: "black",
      contentHeight: 40,
      datesSet: event => {
        if (typeof onDateChange === "function") {
          onDateChange(event.start.getMonth() + 1, event.start.getFullYear())
        }
      },
      eventDidMount: function (args) {
        // TODO :: All event boxes must be hovered
        // TR BEST SVELTE DEVELOPER - START
        function getAllBoxesByReservationID(reservationID) {
          return calendarContainer.querySelectorAll('[data-reservationid="' + reservationID + '"]')
        }
        try {
          const reservationDetails = args.event.extendedProps.reservation_details;
          if (reservationDetails) {
            args.el.parentElement.parentElement.style.setProperty('z-index', 3);
            args.el.parentElement.parentElement.onmouseenter = (e) => {
              const allBoxes = getAllBoxesByReservationID(args.el.dataset.reservationid);
              Array.from(allBoxes).forEach((i1) => {
                i1.style.setProperty("background-color", "#EEE");
              });
            };
            args.el.parentElement.parentElement.onmouseleave = (e) => {
              const allBoxes = getAllBoxesByReservationID(args.el.dataset.reservationid);
              Array.from(allBoxes).forEach((i1) => {
                i1.style.setProperty("background-color", "white");
              });
            };
            const titleContainer = args.el.querySelector(".fc-event-title-container");
            if (titleContainer) {
              titleContainer.style.setProperty('--ppimage',"url('" + (reservationDetails?.pp_file?.url || PPPlaceholder) + "')");
              titleContainer.parentElement.parentElement.parentElement.setAttribute('data-reservationid', reservationDetails?.id)
            }
          }
        } catch(err) {
          console.error("Error while processing calendar images", err);
        }
        // TR BEST SVELTE DEVELOPER - END
      },
      eventClick: onReservationClick,
    });
    calendarInstance.render();
    calendarContainer.classList.add("app-fullcalendar2");
  }

  export function initializeEvents(reservations) {
    if (reservations) {
      const events = reservations.map((i1) => {
        return {
          title: i1.guest_name,
          start: i1.check_in.split(' ')[0],
          end: i1.check_out.split(' ')[0],
          reservation_details: i1,
        };
      });
      calendarInstance.removeAllEvents();
      calendarInstance.addEventSource(events);
    }
  }

  function onReservationClick(reservationBox) {
    selectedReservation = reservationBox.event.extendedProps.reservation_details;
  }

  function onDrawerClose() {
    selectedReservation = null;
  }
</script>

<Card>
  <div class="row position-relative">
    <div
      bind:this={calendarContainer}
      id="calendar"
      class="app-fullcalendar"
      style={!selectedProperty ? "filter:blur(5px)" : "transition: filter 0.4s ease-in-out;"}
    />
  </div>
  <ReservationDrawer
    propertyDetails={selectedProperty}
    reservationDetails={selectedReservation}
    onClose={onDrawerClose}
  />
</Card>
